function formatDateWithSuffix(isoDate) {
  const [y, m, d] = isoDate.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 1, d)); // avoid timezone shifts

  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[date.getUTCMonth()];

  const suffix =
    day % 100 >= 11 && day % 100 <= 13
      ? 'th'
      : day % 10 === 1
        ? 'st'
        : day % 10 === 2
          ? 'nd'
          : day % 10 === 3
            ? 'rd'
            : 'th';

  return `${day}${suffix} ${month} ${year}`;
}

function getProductEtaDate(variantId, qty, metaData) {
  for (const variant of metaData) {
    if (variant.variant_id == variantId) {
      const ranges = variant.ranges;
      for (const r of ranges) {
        if (qty >= r.min && qty <= r.max) {
          return r.eta;
        }
      }
    }
  }
  return null;
}

let setCartAttribute = (Eta) => {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: {
        ETA: Eta,
      },
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      let etaText = document.querySelector('#cartEtaDisplay span');
      if (etaText) {
        etaText.innerText = data.attributes.ETA;
      }
      let etaDrawerText = document.querySelector('#cartDrawerEtaDisplay span');
      if (etaDrawerText) {
        etaDrawerText.innerText = data.attributes.ETA;
      }
    });
};

let updateEta = () => {
  const cartItems = [];
  const totalDatesFound = [];
  fetch('/cart.js')
    .then((response) => response.json())
    .then((data) => {
      data.items.forEach((item) => {
        cartItems.push({
          variant_id: item.variant_id,
          quantity: item.quantity,
        });
      });
    })
    .then(() => {
      let etaData = JSON.parse(localStorage.getItem('rawEta') || '[]');
      cartItems.forEach((item) => {
        let datefound = getProductEtaDate(item.variant_id, item.quantity, etaData);
        totalDatesFound.push(datefound);
      });
    })
    .then(() => {
      if (totalDatesFound.length > 0) {
        const latestDate = totalDatesFound.reduce(
          (max, curr) => (new Date(curr) > new Date(max) ? curr : max),
          totalDatesFound[0]
        );
        let formatedDate = formatDateWithSuffix(latestDate);
        setCartAttribute(formatedDate);
      } else {
        console.log('no date found');
      }
    })
    .catch(() => {
      console.log('error in getting latest estamated delivery date');
    });
};


//select all cart-product-info elements and get the data-selected-variant-id 
let getSelectedVariantId = () => {
  const cartProductInfoElements = document.querySelectorAll('.cart-product-info');
  cartProductInfoElements.forEach(element => {
    const selectedVariantId = element.dataset.selectedVariantId;
    updateCartItemsEta(selectedVariantId);
  });
};

const updateCartItemsEta = (selectedVariantId) => {
  let etaData = JSON.parse(localStorage.getItem('rawEta') || '[]');
  etaData.forEach(item => {
    if (item.variant_id == selectedVariantId) {
      updateTargetCartItemEta(selectedVariantId, item.ranges);
    }
  });
}

const updateTargetCartItemEta = (selectedVariantId, ranges) => {
  let targetDiv = document.querySelector(`[data-selected-variant-id="${selectedVariantId}"]`);
  let closestQtyInput = targetDiv.parentElement.querySelector('.cart-qty');
  let currentQty = parseInt(closestQtyInput.value);
  let etaDateText = cartItemEtaDate(selectedVariantId, currentQty, ranges);
  if (targetDiv && etaDateText) {
    let convertedDate = formatDateWithSuffix(etaDateText);
    targetDiv.querySelector('.cart-item-eta-date-text').innerText = 'Est. Dispatch: ' + convertedDate;
  }
}

const cartItemEtaDate = (selectedVariantId, currentQty, ranges) => {
  for (const r of ranges) {
    if (currentQty >= r.min && currentQty <= r.max) {
      return r.eta;
    }
  }
  return null;
}

let etaTimeout;
let getSelectedVariantIdTimeout;
window.addEventListener('cart:updated', function () {
  clearTimeout(etaTimeout);
  clearTimeout(getSelectedVariantIdTimeout);
  etaTimeout = setTimeout(updateEta, 600);
  getSelectedVariantIdTimeout = setTimeout(getSelectedVariantId, 1000);
});
window.addEventListener('cart-drawer:added', function () {
  getSelectedVariantIdTimeout = setTimeout(getSelectedVariantId, 1000);
});

window.addEventListener('cart-drawer:updated', function () {
  updateEta();
  getSelectedVariantIdTimeout = setTimeout(getSelectedVariantId, 1000);
});

window.addEventListener('DOMContentLoaded', function () {
  updateEta();
  getSelectedVariantIdTimeout = setTimeout(getSelectedVariantId, 1000);
});

